<template>
  <div class="wrap">
    <div :class="['content', `tab-${tab}`]">
      <base-header
        :name="user_name"
        :topOnly="flag_top"
        :account_list="account_list"
      ></base-header>
      <!-- tab=1：领取页；tab=2：已领取结果 -->
      <div class="part part1" v-if="tab === 1">
        <div
          :class="['lq-btn', btn_lock ? 'loading' : '']"
          @click="onReceive"
        ></div>
      </div>
      <div class="part part2" v-else-if="tab === 2">
        <ul class="award-list">
          <li
            class="award-item"
            v-for="(item, index) in awardList"
            :key="index"
          >
            <div class="award-img">
              <img
                :src="
                  'https://cdn.09game.com/resources/item/dj_' +
                    item.id +
                    '_200.png'
                "
                :alt="item.name"
              />
            </div>
            <div class="award-info">
              <p class="award-name">{{ item.name }}</p>
              <p class="award-desc">{{ item.desc }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="mate-info"></div>
    </div>
  </div>
</template>

<script>
import { baseUrls } from "@/utils/baseUrlConfig";
const base_url = baseUrls.user_url;
const hd_url = "https://hd.09game.com/box_lottery/";

// 奖励配置：接口返回 id 时用来补全名称/说明
const AWARD_MAP = {
  0: {
    name: "酒豆",
    desc:
      "平台商城及地图内部分道具功能可用（购买皮肤、重转英雄、重转宝箱、重转符文等）"
  },
  20036: {
    name: "普通宝箱",
    desc: "本期皮肤嘉年华专题中，可以用于抽取精美皮肤"
  },
  20008: {
    name: "皮肤碎片",
    desc: "本期皮肤嘉年华专题中，可用于兑换皮肤"
  },
  20049: {
    name: "半价BUFF",
    desc: "本期皮肤嘉年华专题中，下一次酒币开箱仅需 240 酒币"
  },
  20050: {
    name: "双倍至尊宝箱BUFF",
    desc: "本期皮肤嘉年华专题中，下一次酒币开箱抽到至尊宝箱时双倍获得"
  },
  20077: {
    name: "开一返一BUFF",
    desc: "本期皮肤嘉年华专题中，下一次酒币开箱，额外送一个普通宝箱"
  },
  20041: {
    name: "2400酒豆BUFF",
    desc: "本期皮肤嘉年华专题中，下一次酒币开箱额外获得2400酒豆*有效期7天"
  }
};

export default {
  name: "welfare",
  data() {
    return {
      token: this.$storage.getToken(),
      user_name: "",
      flag_top: true,
      account_list: [],
      tab: 1,
      awardList: [],
      btn_lock: false,
      timer: null
    };
  },
  mounted() {
    this.requireToken();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (vm.$common.checkToken(vm.token)) {
        vm.$http.set_anchor(17, vm.token);
      }
    });
  },
  methods: {
    requireToken() {
      var Ucookie = this.token;
      if (Ucookie != null) {
        var now = new Date().getTime();
        if (now >= Ucookie.split("-")[3] * 1000) {
          this.get_auth();
        } else {
          this.init();
        }
      } else {
        this.get_auth();
      }
    },
    init() {
      this.token = this.$storage.getToken();
      this.query_user_baseInfo();
      this.getLotteryRecord();
    },
    get_auth() {
      window.location.replace(base_url + "/GetWxOpenid?fromPage=welfare");
    },
    query_user_baseInfo() {
      if (!this.token) return;
      $.ajax({
        url:
          "https://users.09game.com/home/GetUserPub?user_id=" +
          this.token.split("-")[0],
        success: res => {
          if (res.result == 0) {
            var u = res.temp[0];
            this.user_name = u.user_name;
            this.$storage.setUserId(u.user_id);
            this.$storage.setUserName(u.user_name);
          }
        }
      });
      this.$http.getAllUser(this.token).then(res => {
        if (res.result == 0 && res.msg && res.msg.length > 0) {
          this.account_list = res.msg;
          this.$storage.setAccountList(JSON.stringify(res.msg));
        } else {
          this.account_list = [];
        }
      });
    },
    // 统一把接口奖励转成列表展示结构（过滤没抽中）
    formatAwards(list) {
      if (!list || !list.length) return [];
      return list
        .filter(item => {
          const id = item.item_id != null ? item.item_id : item.id;
          return id >= 0;
        })
        .map(item => {
          const id = item.item_id != null ? item.item_id : item.id;
          const conf = AWARD_MAP[id] || {};
          return {
            id: id,
            name: item.item_name || item.name || conf.name || "",
            desc: conf.desc || "",
            amount: item.amount,
            category: item.category
          };
        });
    },
    queryIn(api, success, error) {
      $.ajax({
        url: hd_url + api + "?token=" + this.token,
        success: res => {
          success && success(res);
        },
        error: () => {
          error && error();
        }
      });
    },
    // 查抽奖记录：msg 为空数组 = 未抽；有数据则展示
    getLotteryRecord() {
      this.queryIn(
        "GetLotteryRecord",
        res => {
          if (res.code == 0) {
            const list = Array.isArray(res.data)
              ? res.data
              : Array.isArray(res.msg)
              ? res.msg
              : [];
            const awards = this.formatAwards(list);
            if (awards.length > 0) {
              this.awardList = awards;
              this.tab = 2;
            } else {
              this.awardList = [];
              this.tab = 1;
            }
          } else {
            this.tab = 1;
          }
        },
        () => {
          this.tab = 1;
        }
      );
    },
    // 抽奖 / 领取
    onReceive() {
      if (this.btn_lock) return;
      this.btn_lock = true;
      let element = ".wrap .content .part1 .lq-btn";
      this.queryIn(
        "DoLottery",
        res => {
          if (res.code == 0) {
            const awards = this.formatAwards(
              Array.isArray(res.data) ? res.data : []
            );
            this.awardList = awards;
            this.mate_show(
              element,
              typeof res.msg === "string" ? res.msg : "领取成功",
              -50,
              5
            );
            setTimeout(() => {
              this.hide_mate();
              this.btn_lock = false;
              this.tab = 2;
            }, 500);
          } else {
            this.btn_lock = false;
            this.mate_show(
              element,
              typeof res.msg === "string" ? res.msg : "领取失败",
              -50,
              5
            );
          }
        },
        () => {
          this.btn_lock = false;
          this.mate_show(element, "网络异常，请稍后重试", -50, 5);
        }
      );
    },
    hide_mate() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      $(".mate-info")
        .hide()
        .html("");
    },
    mate_show(element, text, offsetTop, offsetLeft = 5) {
      $(".mate-info").html(text);
      var width1 = $(element).width();
      var width = $(".mate-info").width() + 44;
      var offWidth = (width1 - width) / 2;
      var top = $(".content").offset().top;
      var cssTop = $(element).offset().top - top + offsetTop;
      var cssLeft = $(element).offset().left + offWidth + offsetLeft;
      var css = {
        top: cssTop,
        left: cssLeft
      };
      if (this.timer) {
        clearTimeout(this.timer);
      }
      $(".mate-info")
        .show()
        .css(css);
      this.timer = setTimeout(() => {
        this.hide_mate();
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/welfare/index.scss";
</style>



// WEBPACK FOOTER //
// src/view/welfare.vue